import getExtendedPropertyValue from 'owa-mail-store/lib/utils/getExtendedPropertyValue';
import Message from 'owa-service/lib/contract/Message';

// The ExtendedUri property tag for the last user action recieved in the GetItem api
const LAST_ACTION_PROPERTY_TAG = '0x1081';

// The ExtendedUri property tag for the last user action time recieved in the GetItem api
const LAST_ACTION_TIME_PROPERTY_TAG = '0x1082';

/**
 * This method calculates last user action type from the property tag in the item
 * @param item - Message item that contains property tag for the user action
 */
export function getUserLastActionForMessageItem(item: Message): string {
    const extendedPropertyValue = getExtendedPropertyValue(item, LAST_ACTION_PROPERTY_TAG);
    return extendedPropertyValue;
}

/**
 * This method calculates last user action time from the property tag in the item
 * @param item - Message item that contains property tag for the user action time
 */
export function getUserLastActionTimeForMessageItem(item: Message): string {
    const extendedPropertyValue = getExtendedPropertyValue(item, LAST_ACTION_TIME_PROPERTY_TAG);
    return extendedPropertyValue;
}
